import { SupplierRelationshipListResponseType } from "@sellar-io/api-v2/types";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { Icon } from "@sellar-io/components";
import { PaymentTermsIndicator } from "../paymentTypeIndicator/PaymentTermsIndicator";

export const ConnectionPaymentTermsRequestIndicatorChange = ({
  connection,
}: {
  connection: Pick<
    SupplierRelationshipListResponseType[number],
    | "paymentTerms"
    | "paymentDueCalculateFrom"
    | "paymentDue"
    | "PaymentTermsRequest"
  >;
}) => {
  const { business } = useSellarCurrentBusiness();
  if (!business?.Supplier) return;
  const invoiceCreationStage = business.Supplier.invoiceCreationStage;
  const requestedPaymentTerms = connection.PaymentTermsRequest;
  if (!requestedPaymentTerms || requestedPaymentTerms.status !== "pending")
    return;
  return (
    <div className="flex flex-row items-center gap-2">
      <PaymentTermsIndicator
        connection={connection}
        invoiceCreationStage={invoiceCreationStage}
      />
      <Icon icon={"ARROW_RIGHT"} />
      <PaymentTermsIndicator
        connection={{
          paymentDue: requestedPaymentTerms.paymentDue,
          paymentDueCalculateFrom:
            requestedPaymentTerms.paymentDueCalculateFrom,
          paymentTerms: "credit",
        }}
        invoiceCreationStage={invoiceCreationStage}
      />
    </div>
  );
};
